/* eslint-disable no-unused-vars */
import React, { useMemo, useState, useEffect, useContext } from 'react';
// MUI
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Tabs, Tab, Alert } from '@mui/material';
import TabPanel from '../../components/TabPanel';

// Components
import Filter from './components/Filter';
import Table from './components/Table';
// API
import { getMdMasterlist } from '../../api/mdProfileApi';
// Context
import useMasterlistContext from './context/useMasterlistContext';
import AppConst from '../../components/AppLayout/const';
import { DashboardProvider } from '../Dashboard/useDashboard';
import moment from 'moment';
import { toast } from 'react-toastify';

export default function MDMasterlist() {
  const { onSetTitle } = useContext(AppConst.AppContext);
  onSetTitle('MD Masterlist');

  const defaultFilterForm = {
    team: { label: 'ALL', value: null },
    rep_id: { label: 'ALL', value: null },
    md_id: [{ label: 'ALL', value: null }],
    month_year: moment().format('YYYY-MM'),
  };

  // STATE
  const [activeTab, setActiveTab] = useState(0);
  const [filterForm, setFilterForm] = useState(defaultFilterForm);
  const [listGenerated, setListGenerated] = useState(false);
  const [masterlists, setMasterlist] = useState({ loading: false, items: [] });
  const [clearFilter, setClearFilter] = useState(true);

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleGeneratelist = async (e, filters = filterForm) => {
    toast.loading('Processing request please kindly wait...');
    setMasterlist({ ...masterlists, loading: true });
    setListGenerated(true);
    console.log('filters', filters);
    const request = {
      team: filters?.team?.value,
      rep_id: filters?.rep_id?.value,
      md_id: filters?.md_id[0]?.value !== null ? filters?.md_id?.map((row) => row.value) : [],
      year: moment(filters?.month_year).format('YYYY'),
      month: moment(filters?.month_year).format('M'),
    };

    const response = await getMdMasterlist(request);
    const { code, data } = response?.data;

    if (code === '200') {
      toast.dismiss();
      setMasterlist({ ...masterlists, loading: false, items: data });
    }
  };
  const handleClearList = async () => {
    setFilterForm(defaultFilterForm);
    const rand = moment().format('msS');
    setClearFilter(rand);
    handleGeneratelist(false, defaultFilterForm);
  };

  return (
    <DashboardProvider>
      <useMasterlistContext.Provider
        value={useMemo(
          () => ({
            // GET
            filterForm,
            masterlists,
            // SET
            setFilterForm,
            // METHOD
            handleGeneratelist,
            handleClearList,
          }),
          [filterForm, masterlists],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={12} md={12}>
                  <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={activeTab}
                        onChange={handleChangeActiveTab}
                        aria-label='basic tabs example'
                      >
                        <Tab
                          label='Masterlist'
                          id='masterlist-tab'
                          aria-controls='masterlist-tab'
                        />
                      </Tabs>
                    </Box>
                    <TabPanel value={activeTab} index={activeTab}>
                      {listGenerated ? (
                        <Table />
                      ) : (
                        <Box mt={2}>
                          <Alert variant='outlined' severity='info'>
                            Please generate report
                          </Alert>
                        </Box>
                      )}
                    </TabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </useMasterlistContext.Provider>
    </DashboardProvider>
  );
}
